<!-- src/components/modals/AulasAvulsasModal.vue -->
<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <div class="modal-header">
        <h6>Aulas Avulsas Agendadas</h6>
        <i
          class="bi bi-x-circle close-icon"
          @click="emit('fechar')"
          title="Fechar"
        />
      </div>
      <div class="table-container">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <!-- <th>Aula Avulsa</th> -->
              <th>Aluno</th>
              <th>Turma</th>
              <th>Agendamento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!aulas.length">
              <td colspan="5" class="text-center">Nenhuma aula avulsa agendada.</td>
            </tr>
            <tr v-for="item in aulas" :key="item.id">
              <!-- <td>{{ item.aula_avulsa_id }}</td> -->
              <td>{{ item.aluno_nome }}</td>
              <td>{{ item.turma_completa }}</td>
              <td class="text-primary">{{ formatDate(item.data_aula) }}</td>
              <td class="text-center">
                <button
                  class="btn btn-link p-0"
                  @click="emit('detalhar', item.aula_avulsa_id)"
                  title="Detalhar"
                >
                  <i class="bi bi-arrow-right-circle action-icon"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, toRefs } from 'vue'

const props = defineProps({
  mostrar: { type: Boolean, default: true },
  aulas:   { type: Array,   default: () => [] }
})
const { mostrar, aulas } = toRefs(props)

const emit = defineEmits(['fechar', 'detalhar'])

function formatDate(d) {
  const [year, month, day] = d.split('-').map(Number);
  const date = new Date(year, month - 1, day); // cria dia às 00:00 no local
  return date.toLocaleDateString('pt-BR');
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}

.action-icon:hover {
  color: #0056b3;
}
</style>
